import * as $ from 'jquery';
import * as validate from "../../lib/validate.min.js";

/**
 * Setting the email pattern according to the RegExp found at http://emailregex.com/
 * @type {RegExp}
 */
validate.validators.email.PATTERN = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

validate.validators.datetime.parse = function(value, options) {
	return new Date(value).valueOf()
};

validate.validators.datetime.format = function(value, options) {
	return new Date(value);
}

// window['validate'] = validate;

/**
 *
 * @param options {object} containing the values to check
 *  @option values {object} Key Value pairs with the actual form values
 *  @option constraints {object} Key Definitions pairs with witch to validate the values
 *
 * @return {boolean} true if no error else false
 */
export function validateWrapper(options) {
	let result = validate(options.values, options.constraints);

	$('.has-error').removeClass('has-error');
	$('.form-error-message').remove();
	if (result) {
		$.each(result, function (key, val) {
			let $element = $(`[name="${key}"]`).eq(0);
			let error = `<div class="form-error-message">${val[0]}</div>`;

			if ($element.hasClass('dirty') || $element.is(':file')) {
				if ($element.is(':checkbox')) {
					$element.parents('.form-group').addClass('has-error').append(error);
				} else if ($element.is(':radio')) {
					$element.parents('.form-group').addClass('has-error').after(error);
				} else if ($element.is(':file')) {
					$element.parents('.form-group').addClass('has-error').after(error);
				} else {
					$element.parent().addClass('has-error');
					if ($element.siblings('.input-group-btn').length) {
						$element.parent().after(error);
					} else {
						$element.after(error);
					}
				}
			}
		});
	}

	return result === undefined || result.length === 0;
}

function removeFromArray(array, element) {
	const index = array.indexOf(element);

	if (index !== -1) {
		array.splice(index, 1);
	}
}

export function validateWrapperSubmit(options) {
	let $errorList = $('.js-issues-need-correction');
	let result = validate(options.values, options.constraints);
	$errorList.empty();

	if (result) {
		//result.toString();

		//removeFromArray(result, "Photo must be provided");

		$.each(result, function (key, val) {
			let error = `<li>${val[0]}</li>`;
			$errorList.append(error);
		});
	}

	console.log(result);

	return result === undefined || result.length === 0;
}

export function resetForm($form) {
	$form[0].reset();
	$form.find('.has-error').removeClass('has-error');
	$form.find('.dirty').removeClass('dirty');
	$form.find('.form-error-message').remove();
}



// WEBPACK FOOTER //
// ./js/PFF/modules/formValidation.ts